/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react';
import { DotLottie } from '@lottiefiles/dotlottie-web';

function useDotLottie (props = { src: '', loop: true, autoplay: true }) {

  const {
    src,
    loop = true,
    autoplay = true,
  } = props;

  const canvasRef = useRef(null);

  useEffect(() => {
    const dotLottie = new DotLottie({
      canvas: canvasRef.current,
      src,
      loop,
      autoplay,
    });

    return () => {
      dotLottie.destroy();
    };
  }, [src, loop, autoplay]);

  return {
    canvasRef,
  };
}

export default useDotLottie;
